import { CommonModule } from '@angular/common';
import { NgModule, inject, provideAppInitializer } from '@angular/core';

import { ThemeService } from './services/theme.service';

/**
 * Factory function for APP_INITIALIZER
 * @param themeService
 */
export function loadTheme(themeService: ThemeService) {
  return () => {
    return themeService
      .fetch()
      .toPromise()
      .finally(() => Promise.resolve());
  };
}

@NgModule({
  imports: [CommonModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = loadTheme(inject(ThemeService));
      return initializerFn();
    }),
  ],
})
export class UiModule {}
